"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderComponentPluginDefintion = void 0;
const RactiveComponentPlugin_1 = require("auto-widget-framework/src/Plugin/RactiveComponent/RactiveComponentPlugin");
const RactiveComponentPluginDefinition_1 = require("auto-widget-framework/src/Plugin/RactiveComponent/RactiveComponentPluginDefinition");
const Ractive = require("ractive");
class LoaderComponent extends RactiveComponentPlugin_1.default {
    /**
     * @inheritDoc
     */
    getElementName() {
        return "loader";
    }
    /**
     * @inheritDoc
     */
    getComponent() {
        return Ractive.extend({
            /* tslint:disable */
            template: "<div class=\"lds-css ng-scope\" style=\"width: 100px; height: 50px;\"><div class=\"lds-spinner\" style=\"100%;height:100%\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>",
        });
    }
}
exports.default = LoaderComponent;
exports.LoaderComponentPluginDefintion = new RactiveComponentPluginDefinition_1.default({
    id: "loader_component",
    class: LoaderComponent
});
